import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { authenticateFigma } from 'actions/integrations/figma';
import { deactivateIntegration, activatingIntegrationSuccedded } from 'actions/integrations/integrations';

import { Button, Image } from "react-bootstrap";
import _ from 'lodash';
import cx from 'classnames';

import { ShortLoader } from 'components/ApplicationLoader';

import { getBaseUrl } from "services/util";

import styles from './figma.module.scss';

const client_id = process.env.REACT_APP_FIGMA_CLIENT_ID;

export const FigmaIntegrationCard = ({data, index}) => {

  const dispatch = useDispatch();

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const workspace = useSelector(state => _.get(state, 'workspaces.workspace.item', {}));
  const workspaceId =  _.get(workspace, 'id', null)
  const errors = useSelector(state => _.get(state, 'integrations.figma.changes.error', null));

  const currentURL = window.location.href;
  let baseUrl = getBaseUrl(currentURL);

  const [authenticated, setAuthenticated] = useState(false);
  const [deactivationIntiated, setDeactivationIntiated] = useState(false);

  const integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type === 'figma';
  })

  const activated = integration != null;

  useEffect(state => {
    if (integration && integration.state.code === "ok" && !errors) {
      setAuthenticated(true);
    } else {
      setAuthenticated(false);
    }
  }, [integration]);

  const handleDeactivate = () => {
    dispatch(deactivateIntegration('figma', (res) => {
      setDeactivationIntiated(false)
    }))
  }

  const handleLogin = () => {
    const redirect_uri = `${baseUrl}/integrations/figma/callback`;
    const scope = 'files:read';
    const authUrl = `https://www.figma.com/oauth?response_type=code&client_id=${client_id}&redirect_uri=${redirect_uri}&scope=${scope}&state=${workspaceId}`;
    window.location.href = authUrl;
  };

  const handleIntegration = () => {
    if(activated){
      setDeactivationIntiated(true)
      return
    }

    handleLogin()
  }

  return (
    <div key={index} onClick={!deactivationIntiated ?  handleIntegration : ()=>{}} className={cx(styles.figmaIntegrationCard, { [styles.activated]: activated })}>
      {deactivationIntiated ?
        <div className={styles.warningMsg}>
          <span>Are you sure you want to deactivate the Figma integration?</span>
          <div className={styles.btnGroup}>
            <Button variant='secondary' onClick={()=>setDeactivationIntiated(false)}> Cancel </Button>
            <Button variant='primary' onClick={handleDeactivate}> Deactivate </Button>
          </div>
        </div>
        :
        <div className={styles.contentWrapper}>
          <div className={styles.logoContainer}>
            <Image src={data.icon} />
          </div>
          <h4 className={styles.name}>{data.title}</h4>
          <p className={styles.description}>{data.description}</p>
        </div>
      }
      {!deactivationIntiated &&
        <div className={styles.actionContainer}>
          {activated && <Button variant='secondary' className={cx(styles.button, { [styles.activatedBtn]: activated })}>Activated</Button>}
          {!activated && <Button variant='secondary' className={styles.button}>Activate</Button>}

          {activated && <Button variant='secondary' className={cx(styles.button, styles.deactivateBtn)}>Deactivate</Button>}
        </div>
      }
    </div>
  )
}

export const FigmaAuthenticationCallback = () => {
  const dispatch = useDispatch();

  const currentURL = window.location.href;

  let baseUrl = getBaseUrl(currentURL);

  const params = new URLSearchParams(window.location.search);

  useEffect(state => {
    const code = params.get('code');
    const workspace = params.get('state');
    if(code){
      dispatch(authenticateFigma(code, workspace, (response) => {
        dispatch(activatingIntegrationSuccedded(response));
        window.location.replace(`${baseUrl}/app/${workspace}/integration-settings/integration`);
      }))
    }
  }, []);

  return <ShortLoader title="Authenticating Figma..." />
}